/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Is_Base_RoleInputs */

const en_tables_users_is_base_role = /** @type {(inputs: Tables_Users_Is_Base_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base Role`)
};

const de_tables_users_is_base_role = /** @type {(inputs: Tables_Users_Is_Base_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base Role`)
};

/**
* | output |
* | --- |
* | "Is Base Role" |
*
* @param {Tables_Users_Is_Base_RoleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_is_base_role = /** @type {((inputs?: Tables_Users_Is_Base_RoleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Is_Base_RoleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_is_base_role(inputs)
	return de_tables_users_is_base_role(inputs)
});